// ---- SCROLL REVEAL ----
const revealEls = document.querySelectorAll('.reveal');
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
      observer.unobserve(entry.target);
    }
  });
}, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

revealEls.forEach(el => observer.observe(el));

// ---- FAQ ACCORDION ----
document.querySelectorAll('.faq-q').forEach(btn => {
  btn.addEventListener('click', () => {
    const item = btn.closest('.faq-item');
    const isOpen = item.classList.contains('open');

    // Close all
    document.querySelectorAll('.faq-item.open').forEach(openItem => {
      openItem.classList.remove('open');
    });

    // Open clicked if it was closed
    if (!isOpen) {
      item.classList.add('open');
    }
  });
});

// ---- HOW IT WORKS — Step interaction ----
const howSteps = document.querySelectorAll('.how-step');
const stepImages = document.querySelectorAll('.step-image');
const stepDots = document.querySelectorAll('.step-dot');

function activateStep(index) {
  // Update steps
  howSteps.forEach((s, i) => s.classList.toggle('active', i === index));
  // Update images
  stepImages.forEach((img, i) => img.classList.toggle('active', i === index));
  // Update dots
  stepDots.forEach((dot, i) => dot.classList.toggle('active', i === index));
}

// Click on step row
howSteps.forEach((step, i) => {
  step.addEventListener('click', () => activateStep(i));
});

// Click on dots
stepDots.forEach((dot, i) => {
  dot.addEventListener('click', () => activateStep(i));
});

// Auto-advance every 3 seconds
let stepTimer = setInterval(() => {
  const current = Array.from(stepImages).findIndex(img => img.classList.contains('active'));
  activateStep((current + 1) % 3);
}, 3000);

// Pause auto-advance on manual interaction
howSteps.forEach(step => step.addEventListener('click', () => {
  clearInterval(stepTimer);
}));
stepDots.forEach(dot => dot.addEventListener('click', () => {
  clearInterval(stepTimer);
}));

// Email sign-up handler
function handleSignup(e) {
  e.preventDefault();
  const input = e.target.querySelector('.signup-input');
  const btn = e.target.querySelector('.signup-btn');
  const email = input.value.trim();
  if (!email) return;

  btn.textContent = 'Subscribing...';
  btn.disabled = true;

  const data = {
    data: {
      type: 'subscription',
      attributes: {
        profile: {
          data: {
            type: 'profile',
            attributes: {
              email: email,
              subscriptions: {
                email: {
                  marketing: {
                    consent: 'SUBSCRIBED'
                  }
                }
              }
            }
          }
        }
      },
      relationships: {
        list: {
          data: { type: 'list', id: 'TeWdVy' }
        }
      }
    }
  };

  fetch('https://a.klaviyo.com/client/subscriptions/?company_id=RpvWr4', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/vnd.api+json',
      'revision': '2026-01-15'
    },
    body: JSON.stringify(data)
  })
  .then(res => {
    if (res.status === 202) {
      btn.textContent = 'Thanks! ✓';
      btn.style.background = '#c4785a';
      btn.style.color = '#fff';
      btn.disabled = false;
      input.value = '';
      input.placeholder = "You're on the list!";
      setTimeout(() => {
        btn.textContent = 'Subscribe →';
        btn.style.background = '';
        btn.style.color = '';
        input.placeholder = 'Your email address';
      }, 3000);
    } else {
      return res.json().then(err => { throw err; });
    }
  })
  .catch(err => {
    console.error('Klaviyo signup error:', err);
    btn.textContent = 'Try again';
    btn.disabled = false;
  });
}
